import React from 'react'
import _Input from './Input/Input'

export const Input = ({ onValueChange, ...props }) => {
  const { displayAs, value, icon } = props
  const { linkType, prefix } = (displayAs && displayAs[0]) || {}
  const onChange = (e) => {
    onValueChange && onValueChange(e.target.value)
  }

  return (
    <_Input
      {...props}
      type='text'
      maxLength='80'
      onChange={onChange}
      validRegExp={String.raw`^[^\s@]+@[^\s@.]+\.[^\s@]+$`}
      maskRegExp={String.raw`^$|^([^\s@]+)(?:@)?(?:$|([^\s@.]+)(?:\.)?([^\s@]*$))`}
      maskReplacement='$1@$2.$3'
      icon={value && linkType ? `email` : icon}
      linkType={linkType}
      prefix={prefix}
      value={value}
    />
  )
}

export const Output = ({ data, value, ctx }) => {
  let addr = data || value
  return <a href={ ctx.isConfig ? '#' : `mailto:${addr}`}>{addr}</a>
}
